import styled, { css } from 'styled-components';
import InfoTooltip from './InfoTooltip';

export const IconWithTextDiv = styled.div`
  align-items: center;
  display: inline-flex;
  > div {
    margin-top: 1px;
  }
  > p {
    ${props =>
      !props.iconRight &&
      css`
        padding-left: 20px;
      `}
  }
`;
export const CustomInfoTooltip = styled(InfoTooltip)`
  cursor: pointer;
  position: absolute;
  transform: unset;
  @media screen and (max-width: 767px) {
    div {
      left: 0;
      ::after {
        display: none;
      }
    }
  }
  ${props =>
    props.iconRight &&
    css`
      left: 85px;
    `}
`;

export const LabelP = styled.p`
  color: ${props => props.theme[props.color]};
`;
